import { Button, Result } from "antd";
import { ROUTERS } from "constants/routes.constant";
import { ReactElement } from "react";
import { useNavigate } from "react-router-dom";

const PageNotFoundView = (): ReactElement => {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="404"
      subTitle="申し訳ありませんが、アクセスしたページは存在しません。"
      extra={
        <Button
          type="primary"
          size="large"
          onClick={(): void => navigate(ROUTERS.SERVICE_MANAGEMENT)}
          className="!bg-blue-500 hover:opacity-80"
        >
          ホームに戻る
        </Button>
      }
    />
  );
};

export default PageNotFoundView;
